import { Record } from 'immutable';

export const FileReference = Record({ id: '' }, 'FileReference');
export const NodeReference = Record({ id: '' }, 'NodeReference');
export const PlugReference = Record({ id: '', plug: '' }, 'PlugReference');
export const OperatorReference = Record({ id: '', plug: '', index: 0 }, 'OperatorReference');

export const Vec2 = Record({ x: 0, y: 0 }, 'Vec2');
export const Vec3 = Record({ x: 0, y: 0, z: 0 }, 'Vec3');
export const Color = Record({ r: 0, g: 0, b: 0 }, 'Color');

export default {
  FileReference, NodeReference, PlugReference, OperatorReference,
  Vec2, Vec3, Color,
};



// WEBPACK FOOTER //
// ./src/operators/primitives.js